import { CLASSES } from '../helpers/_global';

export default function pricingSteps(section) {
  const $pricingSteps = section.find('.js-pricing-steps');
  const $imageLines = section.find('.js-pricing-step-line');
  const $pricingStep = $pricingSteps.find('.js-pricing-step');
  const $schemeDesktop = $('.cmp-pricing-platform-scheme__desktop');
  const $schemeTop = '.cmp-pricing-platform-scheme__top-list';
  const $schemeMiddle = '.cmp-pricing-platform-scheme__middle-list';

  const highlightActiveStep = (el) => {
    const dataName = el.attr('data-pricing-step');

    $pricingStep.removeClass(CLASSES.active);
    $imageLines.removeClass(CLASSES.active);

    $pricingSteps.find(`.js-pricing-step[data-pricing-step="${  dataName  }"]`).addClass(CLASSES.active);
    section.find(`.js-pricing-step-line[data-pricing-step="${  dataName  }"]`).addClass(CLASSES.active);
  }

  $schemeDesktop.on('click', '.js-pricing-steps', function() {
    let $el;
    if($(this).parent($schemeTop).length > 0) { $el = $schemeMiddle } else  $el = $schemeTop;

    $('html, body').animate({
        scrollTop: ($($el).offset().top - $($el).height())
    }, 1000);

  });

  $pricingStep.click(function () {
    highlightActiveStep($(this));
  });

  $pricingStep.mouseover(function () {
    highlightActiveStep($(this));
  });
}
